var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 25C20.52 25 25 20.52 25 15C25 9.48 20.52 5 15 5C9.48 5 5 9.48 5 15C5 20.52 9.48 25 15 25ZM15 10C15.55 10 16 10.45 16 11L16 15C16 15.55 15.55 16 15 16C14.45 16 14 15.55 14 15L14 11C14 10.45 14.45 10 15 10ZM14 18L16 18L16 20L14 20L14 18Z",
    fill: "#B20000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error_icon.16e240f44658df34757bdb00f22861fd.svg";
export { ForwardRef as ReactComponent };